import React, { Component } from 'react'
import styled, { withTheme } from 'styled-components';
import { apiPOSTReq } from '../../../Utils/api';
import environment from '../../../environment';
import { ErrorAlert } from '../../Reusable/Alert';
import { CardContainer, Flex, FlexColumn } from '../../Reusable/Container';
import { LabeledInput } from '../../Reusable/Input';
import { Button } from '../../Reusable/Button';
import { LucideBadgeDollarSign, LucideCheck, LucideCheckCheck, LucideCheckCircle, LucideCheckCircle2, LucideCircleDollarSign, LucideFastForward, LucideGlobe, LucideMapPinHouse, LucideZap } from 'lucide-react';
import { Tag, Text } from '../../Reusable/Text';
import hexToRgba from 'hex-to-rgba';
import { InitialCircle } from '../../Reusable/InitialCircle';
import { Divider } from '../../Reusable/Divider';

const OptionBtn = styled.div`
    border: ${props => props.border || `${props.selected ? '1.5px' : '0.7px'} solid ${props.selected ? hexToRgba(props.theme.colors.primary2, 1.0) : props.theme.colors.primary10}`};
    border-radius: 8px;
    padding: ${props => props.padding ? props.padding : '6px 12px'};
    cursor: ${props => (props.onClick == null) ? "unset" : "pointer"};
    margin: ${props => props.margin && props.margin};
    &:hover {
        background: ${props => hexToRgba(props.theme.colors.primary2, 0.04)};
    }
`;

const BorderedCard = styled(FlexColumn)`
    border: ${props => `1px solid ${hexToRgba(props.theme.colors.primary2, 0.08)}`};
    border-radius: 8px;
    padding: 18px 20px;
`;

const RailTag = styled(Flex)`
    border: ${props => `1px solid ${props.theme.colors.primary9}`};
    background-color: ${props => hexToRgba(props.theme.colors.primary9, 0.08)};
    color: ${props => props.theme.colors.primary9};
    border-radius: 12px;
    padding: 0px 6px;
    font-size: 12px;
`;

class NewPaymentMethod extends Component {
    state = {
        accountNumber: this.props.accountNumber,
        routingNumber: this.props.routingNumber,
        existingCP: this.props.existingCP,
        errorField: this.props.errorField,
        selected: "Domestic",
        paymentMethods: this.props.paymentMethods || [],
        addressOnAccount: this.props.addressOnAccount
    }

    handleTextChange = (event) => {
        this.setState({ [event.target.id]: event.target.value });
    }
    
    createDomesticTransferMethods = () => {
        var { accountNumber, routingNumber, addressOnAccount } = this.state;
        var { vendor } = this.props;

        if (!routingNumber) {
            this.setState({ errorField: "routingNumber", errorMessage: "Please enter a valid 9-digit routing number." });
            return
        }

        if (routingNumber && (isNaN(routingNumber) || routingNumber.length != 9)) {
            this.setState({ errorField: "routingNumber", errorMessage: "Please enter a valid 9-digit routing number." });
            return
        }

        if (routingNumber && (isNaN(routingNumber) || routingNumber.length != 9)) {
            this.setState({ errorField: "routingNumber", errorMessage: "Please enter a valid 9-digit routing number." });
            return
        }

        if (!accountNumber) {
            this.setState({ errorField: "accountNumber", errorMessage: "Please enter an account number." });
            return
        }

        if (accountNumber && (isNaN(accountNumber) || accountNumber.length > 17)) {
            this.setState({ errorField: "accountNumber", errorMessage: "Account numbers can only have a maximum of 17 characters." });
            return
        }

        var body = {
            vendorId: vendor.id,
            vendorType: vendor.type,
            bankDetail: {
                accountName: vendor.vendorName || "",
                accountNumber: accountNumber || "",
                routingNumber: routingNumber || "",
                accountType: "Checking",
                addressOnAccount: addressOnAccount
            }
        }

        this.setState({ loading: true });
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/createDomesticTransferMethods`, {}, body, (err, resp) => {
            this.setState({ loading: false });
            try {
                if (err) throw Error(err)
                const data = resp || {}
                if (data.result) {
                    console.log("paymentMethods", data);
                    this.setState({ paymentMethods : data.paymentMethods || [] });
                    this.props.onSave(vendor, data.paymentMethods);
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/createDomesticTransferMethods err", error, resp, body)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    updateDomesticTransferMethod = (pm) => {
        var { addressOnAccount } = this.state;
        var { vendor } = this.props;

        if (!addressOnAccount || !addressOnAccount.line1 || addressOnAccount.line1 === '' || !addressOnAccount.city ||
            addressOnAccount.city === '' || !addressOnAccount.state || addressOnAccount.state === '' || !addressOnAccount.postalCode || addressOnAccount.postalCode === '') {
            this.setState({ errorField: 'addressOnAccount', errorMessage: "Please enter a valid address." })
            return
        }

        var body = {
            vendorId: vendor.id,
            associatedCPObjectId: vendor.associatedCPObjectId,
            paymentMethodId: pm.id,
            bankDetail: {
                addressOnAccount: addressOnAccount
            }
        }

        this.setState({ loading: true });
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/updateTransferMethod`, {}, body, (err, resp) => {
            this.setState({ loading: false });
            try {
                if (err) throw Error(err)
                const data = resp || {}
                if (data.result) {
                    var updatedPM = data.paymentMethod || {};
                    var savedPMs = this.state.paymentMethods;
                    savedPMs = savedPMs.map(pm => {
                        if(pm.id == updatedPM.id) return updatedPM;
                        else return pm;
                    })
                    this.setState({ paymentMethods : savedPMs });
                    this.props.onSave(vendor, savedPMs);
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/updateTransferMethod err", error, resp, body)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    render() {
        var { vendor, theme } = this.props;
        var { errorField, errorMessage, existingCP, pm, loading, selected, paymentMethods, accountNumber, routingNumber, addressOnAccount } = this.state;

        var { id, vendorName } = vendor;

        // var instantPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.Instant Transfer");

        var railOpts = [{ 
            name: 'Domestic', 
            desc: 'Pay instantly or next day',
            logo: <LucideMapPinHouse size={18} color={selected == 'Domestic' ? hexToRgba(theme.colors.primary2, 1.0) : theme.colors.primary10} />,
            selected: (selected == 'Domestic')
        }, { 
            name: 'International', 
            desc: 'Coming soon',
            logo: <LucideGlobe size={18} color={selected == 'International' ? hexToRgba(theme.colors.primary2, 1.0) : theme.colors.primary10} />,
            disabled: true,
            selected: (selected == 'International')
        }];

        var railCards = [{
            name: 'ACH',
            tag: 'Fast',
            desc: 'Next business day delivery',
            icon: <LucideCheckCheck size={14} />
        },{
            name: 'Wire',
            tag: 'Faster',
            desc: 'One hour delivery',
            icon: <LucideFastForward size={14} />
        },{
            name: 'Instant',
            tag: 'Fastest',
            desc: 'Delivery within seconds',
            icon: <LucideZap size={14} />
        }];

        var bankDetails = {
            name: paymentMethods[0]?.bankDetail?.bankName,
            logo: paymentMethods[0]?.bankDetail?.logoUrl
        }

        var pmToUpdate;
        var addrRequired = (paymentMethods || []).find(pm => {
            if(pm.type == "Wire" && !pm.bankDetail?.addressOnAccount?.line1) {
                pmToUpdate = pm;
                return true;
            } else return false;
        });

        return (
            <>
                {
                    paymentMethods.length == 0 ?
                    <FlexColumn gap='24px'>
                        <Flex start gap='16px'>
                            {
                                railOpts.map(item => (
                                    <OptionBtn selected={item.selected} style={{ cursor: !item.disabled ? 'pointer' : 'not-allowed' }}>
                                        <Flex start gap='4px' style={{ padding: '8px' }}>
                                                {item.logo}
                                                <FlexColumn>
                                                    <Text size='16px' height='16px' weight={500} color={item.selected ? hexToRgba(theme.colors.primary2, 1.0) : theme.colors.primary10}>
                                                        {item.name}
                                                    </Text>
                                                    <Text light color={item.selected ? hexToRgba(theme.colors.primary2, 0.8) : theme.colors.primary10}>
                                                        {item.desc}
                                                    </Text>
                                                </FlexColumn>
                                            </Flex>
                                    </OptionBtn>
                                ))
                            }
                        </Flex>
                        <FlexColumn left gap='24px'>
                            <LabeledInput
                                label="Vendor's routing number"
                                id="routingNumber"
                                key="routingNumber"
                                nomargin
                                value={routingNumber}
                                placeholder="Enter up to 9 digits"
                                onChange={this.handleTextChange}
                                maxLength={9}
                                error={errorField === "routingNumber"}
                                errorMessage={errorMessage}
                                autoFocus
                            />
                            <LabeledInput
                                label="Vendor's account number"
                                id="accountNumber"
                                key="accountNumber"
                                nomargin
                                value={accountNumber}
                                placeholder="Enter up to 17 digits"
                                onChange={this.handleTextChange}
                                maxLength={17}
                                error={errorField === "accountNumber"}
                                errorMessage={errorMessage}
                            />
                            <Button style={{ marginTop: '20px' }} loading={loading} onClick={() => this.createDomesticTransferMethods()} text='CONFIRM' />
                        </FlexColumn>
                    </FlexColumn>
                    :
                    <BorderedCard gap='16px'>
                        <Flex start centerH gap='8px'>
                            <InitialCircle logoUrl={bankDetails.logo} />
                            <FlexColumn centerV gap='4px'>
                                <Text heading height='18px'>{bankDetails.name || "--"}</Text>
                                {/* <Flex start centerH gap='4px'>
                                    <LucideCheckCircle2 size={15} color={theme.colors.primary9} />
                                    <Text light>Successfully created</Text>
                                </Flex> */}
                            </FlexColumn>
                        </Flex>
                        <Divider margin='4px 0' />
                        <Text color={hexToRgba(theme.colors.primary2, 0.6)}>We automatically enabled multiple transfer speeds for this institution.</Text>
                        <Flex start stretch gap='16px'>
                            {
                                paymentMethods.map(pm => {
                                    var railCard = railCards.find(rc => rc.name == pm.type) || {};
                                    return (
                                        <BorderedCard start style={{ backgroundColor: hexToRgba(theme.colors.primary2, 0.02), width: '200px' }}>
                                            <FlexColumn left gap='8px'>
                                                <RailTag centerH gap='4px'>
                                                    {railCard.icon}
                                                    {railCard.tag}
                                                </RailTag>
                                                <FlexColumn>
                                                    <Text size='16px' weight={500} height='20px'>{railCard.name}</Text>
                                                    <Text light>{railCard.desc}</Text>
                                                </FlexColumn>
                                            </FlexColumn>
                                        </BorderedCard>
                                    )
                                })
                            }
                        </Flex>
                        {
                            addrRequired &&
                            <>
                                <LabeledInput
                                    label={'Recipient Address'}
                                    id="addressOnAccount"
                                    key="addressOnAccount"
                                    placeholder="Enter Address"
                                    tooltip="To avoid failures, verify that this is the address your recipient has registered with their bank. Tip: Request the recipient for a bank letter"
                                    address={addressOnAccount}
                                    type="location"
                                    getLocation={(addr) => this.setState({addressOnAccount: addr})}
                                    error={errorField === 'addressOnAccount'}
                                    errorMessage="Please enter a valid recipient address"
                                    width='568px'
                                    nomargin
                                    instruction="Recipient address is required for wires"
                                />
                                <Button style={{ marginTop: '20px', alignSelf: "start" }} loading={loading} onClick={() => this.updateDomesticTransferMethod(pmToUpdate)} text='CONFIRM' />
                            </>
                        }
                    </BorderedCard>
                }
            </>
        )
    }
}

export default withTheme(NewPaymentMethod)